import {CLIENT, HAO_DOMAIN, removeLocal} from "helpers/utils.js";

export function fetchDocuments(infoFn, category) {
  let url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents`;
  if (category) {
    url = `${url}?category=${category}`
  }
  return fetch(url, {method: 'GET', credentials: 'include'}).then(res => {
    if (res.status === 200) {
      return res.json();
    } else if (res.status === 401) {
      removeLocal('user');
    }
    throw new Error(`Failed to fetch documents: ${res.status}`);
  }).then(data => {
    if (infoFn) infoFn(data || []);
    return data;
  }).catch(err => {
    console.error('Error fetching documents:', err);
    if (infoFn) infoFn([]);
    removeLocal('user');
    throw err;
  });
}

export function createDocument(documentData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents`;

  return fetch(url, {method: 'POST', credentials: 'include',
    body: JSON.stringify(documentData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to create document: ${res.status}`);
  }).then(data => {
    console.log('Document created successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error creating document:', err);
    throw err; // Re-throw to be handled by the calling component
  });
}

export function updateDocument(documentId, documentData) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents/${documentId}`;

  return fetch(url, {method: 'PUT', credentials: 'include',
    body: JSON.stringify(documentData)
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to update document: ${res.status}`);
  }).then(data => {
    console.log('Document updated successfully:', data);
    return data;
  }).catch(err => {
    console.error('Error updating document:', err);
    throw err;
  });
}

export function deleteDocument(documentId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents/${documentId}`;
  return fetch(url, {
    method: 'DELETE',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return true;
    }
    throw new Error(`Failed to delete document: ${res.status}`);
  }).then(() => {
    console.log('Document deleted successfully');
    return true;
  }).catch(err => {
    console.error('Error deleting document:', err);
    throw err;
  });
}

function downloadLink(url, name) {
  const a = document.createElement('a');
  a.setAttribute('hidden', '');
  a.setAttribute('href', url);
  a.setAttribute('download', name);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function downloadDocument(documentId) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents/${documentId}/download`;
  return fetch(url, {
    method: 'GET',
    credentials: 'include'
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Failed to fetch balance summary: ${res.status}`);
  }).then(data => {
    downloadLink(data.link, data.file)
    return data;
  }).catch(err => {
    console.error('Error fetching balance summary:', err);
    throw err;
  });
}

export function uploadDocument(documentId, blob, onUpload) {
  const url = `${HAO_DOMAIN}/v1/clients/${CLIENT}/documents/${documentId}/upload`;

  return fetch(url, {method: 'GET', credentials: 'include'}).then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw new Error(`Failed to get upload URL: ${res.status}`);
    }
  }).then(data => {
    if (!data.link) {
      throw new Error('No upload URL provided in response');
    }
    return fetch(data.link, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/octet-stream'
      },
      body: blob
    }).then(response => {
      if (response.ok) {
        onUpload();
        return data;
      }
      throw new Error(`Upload failed: ${response.status}`);
    });
  }).catch(error => {
    console.error('Upload error:', error);
    throw error;
  });
}

// Creates the document metadata row and uploads the file in sequence. If the
// upload step fails (expired presigned URL, network issue, S3 bucket CORS
// misconfiguration, etc.) the metadata row is rolled back instead of being
// left behind pointing at a file that was never actually written to S3.
export async function createAndUploadDocument(documentData, file) {
  const createdDoc = await createDocument(documentData);
  try {
    await uploadDocument(createdDoc.id, file, () => {});
    return createdDoc;
  } catch (uploadError) {
    try {
      await deleteDocument(createdDoc.id);
    } catch (rollbackError) {
      console.error('Failed to roll back document after failed upload:', rollbackError);
    }
    throw uploadError;
  }
}
